import React from 'react';
export const SkillRatingCell = ({ skillRating })=>/*#__PURE__*/ React.createElement("div", null, skillRating);
